<ng-container *ngFor="let accountCouple of accountCoupleList;">
  <ng-container *ngIf="accountCouple?.coupleId && accountCouple?.coupleType">
    <ng-container  *ngIf="accountUserList?.[accountCouple.coupleId] as coupleUser else inviteCouple">
      <ion-card class="card-margin">
        <ion-item-sliding #slidingItem>
          <ion-item class="item" (click)="presentUpdateActionSheet(accountCouple.coupleId)" button detail lines="none">
            <ng-container *ngIf="coupleUser?.uid && onlineList && onlineList[coupleUser.uid] && onlineList[coupleUser.uid].online$ | async as presence">
              <ion-avatar slot="start" class="small-avatar" [ngClass]="presence?.online ? 'online-border' : 'offline-border'" *ngIf="coupleUser?.avatar">
                <ng-container *ngIf="coupleUser?.avatar?.url">
                  <ion-img [src]="coupleUser.avatar.url" *ngIf="coupleUser.avatar?.type === 'local'"></ion-img>
                  <app-cached-image [src]="coupleUser.avatar.url" [spinner]="true" *ngIf="coupleUser?.avatar?.type !== 'local'"></app-cached-image>
                </ng-container>
                <ion-icon color="medium" src="./assets/wedding/img/avatar/blank.svg" *ngIf="!coupleUser?.avatar?.url"></ion-icon>
              </ion-avatar>
            </ng-container>
            <ion-label>
              <ion-label class="font-12" color="medium">
                {{ 'LIST.wedding_couple_type.' + accountCouple.coupleType | translate }}<span *ngIf="sameCoupleType">{{ accountCouple.coupleId }}</span>
              </ion-label>
              <ion-label class="font-14 font-med" color="dark" *ngIf="coupleUser.name">
                {{ coupleUser.name }}
              </ion-label>
              <ng-container *ngIf="coupleUser?.owner">
                <ion-label class="font-10" color="medium">({{ 'LIST.role.owner' | translate }})</ion-label>
              </ng-container>
            </ion-label>
          </ion-item>
          <ion-item-options side="end" *ngIf="coupleUser?.uid">
            <ion-item-option color="success" (click)="presentAccountUserModal(accountCouple.coupleId, slidingItem)"><ion-icon src="./assets/wedding/icon/general/edit.svg"></ion-icon></ion-item-option>
            <ion-item-option color="medium" (click)="deleteCoupleConfirm(accountCouple.coupleId, slidingItem)"><ion-icon name="trash-outline"></ion-icon></ion-item-option>
          </ion-item-options>
        </ion-item-sliding>
      </ion-card>
    </ng-container>
    <ng-template #inviteCouple>
      <ion-card class="card-margin" color="tertiary" (click)="checkInviteType(accountCouple.coupleId)" button>
        <ion-item class="invite-item" lines="none" color="tertiary">
          <ion-label class="font-12" color="dark">{{ 'LBL.invite' | translate }} {{ 'LIST.wedding_couple_type.' + accountCouple.coupleType | translate }}<ng-container *ngIf="sameCoupleType"> {{ accountCouple.coupleId }}</ng-container></ion-label>
          <ion-icon class="icon-large ion-no-margin" color="dark" slot="end" name="add-circle"></ion-icon>
        </ion-item>
      </ion-card>
    </ng-template>
  </ng-container>
</ng-container>